import {GET_ASSIGNED_TO, GET_REPORTEE, SEARCH, NEW_ASSIGNEE, UPLOAD_CSV} from "./type";

const initalState = {
    'reportee': [],
    'searchInfo': [],
    'newAssigneeRes':[],
    'uploadcsvfile_1': []
}

const bulkAssignmentReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_REPORTEE:
            return {
                ...state,
                reportee: payload,
            };
        case SEARCH :
            return {
                ...state,
                searchInfo: payload,
            };
        case NEW_ASSIGNEE :
            return {
                ...state,
                newAssigneeRes: payload,
            };
        case UPLOAD_CSV :
            return {
                ...state,
                uploadcsvfile_1: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default bulkAssignmentReducer;